import { render } from "./TopNavBarNames.vue?vue&type=template&id=65214d94"
import script from "./TopNavBarNames.vue?vue&type=script&lang=js"
export * from "./TopNavBarNames.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__